import React from "react";
import {
  CollabHeading,
  CollabButton,
  CollabInfo,
  CollabInfo2,
} from "../../common/strings";
import {
  Container,
  Heading,
  Subtitle,
  ResponsiveText,
  Image,
  Spacing,
} from "./collabComponent";
import { Grid, Button } from "@mui/material";
import { Link } from "react-router-dom";
import girl2 from "../../assets/images/collab/girl2.png";

function App() {
  return (
    <div>
      <Container>
        <Grid container justifyContent="center">
          <Grid item xs={12} style={{ textAlign: "left" }}>
            <Heading style={{ fontSize: "2rem", lineHeight: "normal" }}>
              {CollabHeading}
            </Heading>
            <Image src={girl2} alt="girl2" style={{ bottom: "50px" }} />
            <Subtitle>
              <ResponsiveText>{CollabInfo}</ResponsiveText>
            </Subtitle>
            <Subtitle>
              <ResponsiveText>{CollabInfo2}</ResponsiveText>
            </Subtitle>

            <Link to="/ContactUs" style={{ textDecoration: "none" }}>
              <Button
                variant="contained"
                href="https://gdsc.community.dev/accounts/login/?next=/srm-institute-of-science-and-technology-ramapuram-chennai/"
                target="_blank"
                sx={{
                  borderRadius: "100px",
                  textTransform: "none",
                  backgroundColor: "#005EDB",
                  color: "#FFFFFF",
                  left: "50px",
                  "&:hover": { backgroundColor: "#005EDB", color: "#ffffff" },
                  fontWeight: "700",
                  padding: "20px",
                }}
              >
                {CollabButton}
              </Button>
            </Link>
            <Spacing></Spacing>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default App;
